import { type } from '@ngrx/signals';
import { event, eventGroup } from '@ngrx/signals/events';
import {
  AssetData,
  AssetsRequest,
  CreateRequest, Label,
  PaginatedData,
  PostCommentRequest, PutReviewLabelsRequest,
  ReviewData, ReviewLabels,
  ReviewsRequest,
  UpdateRequest
} from '@models/online-reputation.models';

export const loadReviews = event(
  '[Reviews] Load reviews',
  type<ReviewsRequest>(),
);

export const loadMoreReviews = event(
  '[Reviews] Load more reviews',
  type<ReviewsRequest>(),
);

export const sortReviews = event(
  '[Reviews] Sort reviews',
  type<{ field?: string; direction?: 'ASC' | 'DESC' } | undefined>(),
);

export const searchReviews = event(
  '[Reviews] Search reviews',
  type<{ text: string }>(),
);

export const loadReplyTemplates = event(
  '[Reviews] Load reply templates',
  type<AssetsRequest>(),
);

export const setReplyFormUi = event(
  '[Reviews] Set reply form UI',
  type<{
    activeTab?: string;
    templateMode?: string;
    templateSuccessMessage?: string;
    localTemplateError?: string;
    localSubmitError?: string;
    localGenerateCommentError?: string;
  }>(),
);

export const clearReplyFormLocalErrors = event('[Reviews] Clear reply form local errors');

export const createReplyTemplate = event(
  '[Reviews] Create reply template',
  type<CreateRequest>(),
);

export const updateReplyTemplate = event(
  '[Reviews] Update reply template',
  type<{ id: string; request: UpdateRequest }>(),
);

export const deleteReplyTemplate = event(
  '[Reviews] Delete reply template',
  type<{ id: string }>(),
);

export const submitReviewReply = event(
  '[Reviews] Submit review reply',
  type<PostCommentRequest>(),
);

export const generateComment = event(
  '[Reviews] Generate comment',
  type<{ reviewId: string }>(),
);

export const loadLabels = event(
  '[Reviews] Load labels'
);


export const tagReviewWithLabel = event(
  '[Reviews] Tag review with labels',
  type<PutReviewLabelsRequest>(),
);

export const clearReviews = event('[Reviews] Clear reviews');


export const reviewsApiEvents = eventGroup({
  source: 'Reviews API',
  events: {
    loadReviewsSuccess: type<PaginatedData<ReviewData>>(),
    loadReviewsFailure: type<string>(),
    loadMoreReviewsSuccess: type<PaginatedData<ReviewData>>(),
    loadMoreReviewsFailure: type<string>(),
    loadReplyTemplatesSuccess: type<PaginatedData<AssetData>>(),
    loadReplyTemplatesFailure: type<string>(),
    createReplyTemplateSuccess: type<AssetData>(),
    createReplyTemplateFailure: type<string>(),
    updateReplyTemplateSuccess: type<AssetData>(),
    updateReplyTemplateFailure: type<string>(),
    deleteReplyTemplateSuccess: type<{ id: string }>(),
    deleteReplyTemplateFailure: type<string>(),
    submitReviewReplySuccess: type<{ reviewId: string }>(),
    submitReviewReplyFailure: type<string>(),
    generateCommentSuccess: type<{ content: string }>(),
    generateCommentFailure: type<string>(),
    listLabelsSuccess: type<Label[]>(),
    listLabelsFailure: type<string>(),
    tagReviewWithLabelSuccess: type<{ reviewId: string; labelIds: number[] }>(),
    tagReviewWithLabelFailure: type<string>(),
  }
});
